export const MOBILE_WIDTH = 480
